import React, { Component } from 'react';

import './index.scss';

class AnimatedInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            animated: false,
        }
    }

    componentDidMount() {
        if (this.props.value){
            this.setState({animated: this.props.value !== ''});
        }
    }


    componentDidUpdate(prevProps){
        if (prevProps.value !== this.props.value) {
            this.setState({animated: this.props.value !== ''});
        }
    }

    animatePlaceholder(e) {
        let val = e.target.value;
        this.setState({animated:(val !== '')});
        if(this.props.onChange) {
            this.props.onChange(val, this.props.name);
        }
    }

    render() {
        const {
            type,
            name,
            placeholder = '',
            value = '',
            showError,
            className,
            errorMessage = 'empty or undefined errorMessage prop',
            tabIndex,
            pattern = null,
            ...rest
        } = this.props;


        return (
            <div className = {className + ' animated_input_wrapper animated' + (showError ? ' error' : '') + (this.state.animated ? ' animate' : '')}>
                <label testID = {`animated-input-label-${name}`}>{ placeholder }</label>
                <input type      = { type }
                       name      = { name }
                       value     = { value }
                       onChange  = { (e) => this.animatePlaceholder(e) }
                       tabIndex  = { tabIndex }
                       pattern   = { pattern }
                       testID = {`animated-input-${name}`}
                       {...rest}
                />
                <div testID = {`animated-input-placeholder-${name}`} className="placeholder">{ placeholder }</div>
                {showError ? <div testID = {`animated-input-error-${name}`} className = "error_text">{ errorMessage }</div> : ''}
            </div>
        )
    }
}
export default AnimatedInput;
